module.exports = __webpack_public_path__ + "img/sDrgBlitz_350x350.351c91ae.jpg";